import iconMinus from "./icons/icon-minus.svg";
import iconSetting from "./icons/setting-icon.svg";
import bigCloseIcon from "./icons/big-close-icon.svg";
import noNewIcon from "./icons/no-new-icon.svg";
import notFound from "./icons/notFound.svg";
import maintenance from "./icons/maintenance.svg";
import firstPageIcon from "./icons/first-page-icon.svg";
import lastPageIcon from "./icons/last-page-icon.svg";
import trashIcon from "./icons/trash.svg";
import fiTrendingUp from "./icons/fi_trending-up.svg";
import fiTrendingDown from "./icons/fi_trending-down.svg";
import fiTrendingUpRefund from "./icons/fi_trending-up-refund.svg";
import fiTrendingDownRefund from "./icons/fi_trending-down-refund.svg";
import angleRightIcon from "./icons/angle-right-icon.svg";
import angleLeftIcon from "./icons/angle-left-icon.svg";
import angleLeftIconBlack from "./icons/angle-left-color.svg";
import warningIcon from "./icons/warning.svg";
import warningRedIcon from "./icons/warning-red.svg";
import logoIconLight from "./icons/logo-icon-light.svg";
import completeIcon from "./icons/complete-icon.svg";
import notCompleteIcon from "./icons/not-complete-icon.svg";
import failIcon from "./icons/fail-icon.svg";
import notSyncIcon from "./icons/not-sync-icon.svg";
import exclamationCircleSolid from "./icons/exclamation-circle-solid.svg";
import copyIcon from "./icons/coppy-icon.svg";
import copyIconFill from "./icons/coppy-icon-fill.svg";
import yellowIcon from "./icons/warning-yellow.svg";

//payment icons
import affirm from "./icons/payments/affirm-light.svg";
import afterPay from "./icons/payments/afterpay-light.svg";
import amazon from "./icons/payments/amazon-light.svg";
import amex from "./icons/payments/amex-light.svg";
import applePay from "./icons/payments/apple-pay-light.svg";
import bitcoin from "./icons/payments/bitcoin-light.svg";
import diners from "./icons/payments/diners-light.svg";
import discover from "./icons/payments/discover-light.svg";
import googlePay from "./icons/payments/google-pay-light.svg";
import jcb from "./icons/payments/jcb-light.svg";
import cup from "./icons/payments/cup-light.svg";
import mastercard from "./icons/payments/mastercard-light.svg";
import paypal from "./icons/payments/paypal-light.svg";
import prime from "./icons/payments/prime-light.svg";
import shop from "./icons/payments/shop-light.svg";
import stripe from "./icons/payments/stripe-light.svg";
import visa from "./icons/payments/visa-light.svg";
import angleRightBlack from "./icons/angle-right-black.svg";
import angleDown from "./icons/angle-down.svg";
import angleUp from "./icons/angle-up.svg";
import calendarIcon from "./icons/calendar-icon.svg";
import dotsMenu from "./icons/dots-menu.svg";
import angleLeft from "./icons/angle-left.svg";
import angleRight from "./icons/angle-right.svg";
import downloadIcon from "./icons/download-icon.svg";
import notification from "./icons/notification.svg";
import searchIcon from "./icons/search-icon.svg";
import closeIcon from "./icons/close-icon.svg";
import notificationLight from "./icons/notification-light.svg";
import adminIcon from "./icons/admin-icon.svg";
import superAdminIcon from "./icons/super-admin-icon.svg";
import reportIcon from "./icons/report-icon.svg";
import merchantIcon from "./icons/merchant-icon.svg";
import dashboardIcon from "./icons/dashboard-icon.svg";
import uploadIcon from "./icons/upload.svg";
import loadingIcon from "./icons/loading.svg";
import fileIcon from "./icons/icon-file.svg";
import logo2cpc from "./images/2C2P-logo.png";
import till from "./images/till.svg";
import onePay from "./images/onepay.svg";
import tiloPay from "./images/tilopay.png";
import infoIcon from "./icons/info-icon.svg";
import partnerIcon from "./icons/partner-icon.svg";
import expand from "./icons/expand.svg";
import expandDown from "./icons/expand_down.svg";
import uploadImage from "./icons/upload-image.svg";
import uploadImageFail from "./icons/upload-image-fail.svg";
import warningNoteIcon from "./icons/warning-note-icon.svg";
import newAngleDown from "./icons/new-angle-down.svg";
import threeDSPreview from "./images/3ds_preview.svg";
import redCarbonCircle from "./icons/red-carbon_circle-filled.svg";
import yellowCarbonCircle from "./icons/yellow-carbon_circle-filled.svg";
import greenCarbonCircle from "./icons/green-carbon_circle-filled.svg";
import greenIcon from "./icons/green-icon.svg";
import grayIcon from "./icons/gray-icon.svg";
import notiIcon from "./icons/noti-icon.svg";
import automateTemplateEmail from "./images/automate_template_email.jpg";
import paymentTemplateEmail from "./images/payment_template_email.jpg";
import preauthTemplateEmail from "./images/preauth_template_email.jpg";
import refundTemplateEmail from "./images/refund_template_email.jpg";
import voidTemplateEmail from "./images/void_template_email.jpg";
import vectorMoveTo from "./icons/vector-move_to.svg";
import payoutProcessTemplateEmail from "./images/payout_processed_template_email.jpg";
import payoutFailedTemplateEmail from "./images/payout_failed_template_email.jpg";
import YellowInfo from "./icons/yellow-info.svg";
import automateFailTemplateEmail from "./images/automation_fail_template_email.jpg";
import menuUnFold from "./icons/menuUnFold.svg";
import menuFold from "./icons/menuFold.svg";
import miniKovena from "./images/logo_mini_kovena.svg";
import expandNavigation from "./icons/expand_navigation.svg";
import expandCloseNavigation from "./icons/expand_close_navigation.svg";
import kovenaText from "./images/kovena.svg";
import arrowLeftWhite from "./icons/arrow-left-white.svg";
import arrowRightWhite from "./icons/arrow-right-white.svg";
import virtualTerminalIcon from "./icons/virtual-terminal-icon.svg";
import refundIcon from "./icons/refund-icon.svg";
import cardIcon from "./icons/card.svg";
import errorPayment from "./icons/error-payment.svg";
import successPayment from "./icons/success-payment.svg";
import copyPayment from "./icons/icon-copy-transaction.svg";
import syncTransaction from "./icons/uil_sync-exclamation.svg";
import check from "./icons/check.svg";
import availableWarning from "./icons/blue-info.svg";
import kovenaPwb from "./images/powered_by_kovena.svg";
import processPayoutMulti from "./icons/process-payout-multi.svg";
import warningPayoutMulti from "./icons/warning-payout-multi.svg";
import carbonParentNode from "./icons/carbon_parent-node.svg";

export const assetsImages = {
  logo: require("./images/logo.png"),
  avatar: require("./images/avatar.png"),
  qrCode: require("./images/qrCode.png"),
  bgLogin: require("./images/bg-login.png"),
  bgDisbursement: require("./images/bg-disbursement.png"),
  purpleLogo: require("./images/purpleLogo.png"),
  fillLogo: require("./images/logo-fill.png"),
  dashboardLoader: require("./images/dashboard-loader.png"),
  notificationImg: notificationLight,
  virtualTerminalIcon: virtualTerminalIcon,
  visaImg: require("./images/payments/visa.png"),
  logo2cpc,
  till,
  onePay,
  tiloPay,
  logoDefault: require("./images/logo-default.png"),
  threeDSPreview,
  automateTemplateEmail,
  paymentTemplateEmail,
  preauthTemplateEmail,
  refundTemplateEmail,
  voidTemplateEmail,
  vectorMoveTo,
  payoutProcessTemplateEmail,
  payoutFailedTemplateEmail,
  automateFailTemplateEmail,
  miniKovena,
  kovenaText
};

export const assetsIcons = {
  uploadIcon,
  upload: require("./icons/upload.png"),
  uploadImage,
  uploadImageFail,
  trashIcon,
  warningIcon,
  warningRedIcon,
  logoIconLight,
  completeIcon,
  notCompleteIcon,
  failIcon,
  notSyncIcon,
  fileIcon,
  iconMinus,
  angleRightIcon,
  angleLeftIcon,
  firstPageIcon,
  loadingIcon,
  fiTrendingDown,
  fiTrendingUp,
  fiTrendingUpRefund,
  fiTrendingDownRefund,
  lastPageIcon,
  iconSetting,
  bigCloseIcon,
  angleRightBlack,
  angleLeftIconBlack,
  noNewIcon,
  notFound,
  maintenance,
  help: require("./icons/help.png"),
  notification,
  angleDown,
  newAngleDown,
  angleUp,
  angleLeft,
  angleRight,
  menu: require("./icons/menu.png"),
  dotsMenu,
  iconBottom: require("./icons/icon-bottom.png"),
  btnBack: require("./icons/btn-back.png"),
  searchIcon,
  closeIcon,
  exclamation: require("./icons/exclamation-mark.png"),
  successIcon: require("./icons/success-icon.png"),
  errorIcon: require("./icons/error-icon.png"),
  dashboardIcon,
  merchantIcon,
  partnerIcon,
  reportIcon,
  settingIcon: require("./icons/setting-icon.png"),
  adminIcon,
  superAdminIcon,
  errorIconFill: require("./icons/error-icon-fill.png"),
  errorIconOutline: require("./icons/error-icon-outline.png"),
  errorNotifyIcon: require("./icons/error-notify-icon.png"),
  notiIcon,
  checkIcon: require("./icons/check-icon.png"),
  downloadIcon,
  filterIcon: require("./icons/filter-icon.png"),
  calendarIcon,
  knockOutFace: require("./icons/Knocked-out face.png"),
  iconPlus: require("./icons/icon-plus.png"),
  faceSad: require("./icons/face-sad.png"),
  nomupay: require("./images/nomupay.png"),
  paydock: require("./images/paydock.png"),
  infoIcon,
  payments: {
    light: {
      affirm,
      afterPay,
      amazon,
      amex,
      applePay,
      bitcoin,
      diners,
      discover,
      googlePay,
      jcb,
      mastercard,
      paypal,
      prime,
      shop,
      stripe,
      visa,
      cup,
    },
  },
  expand,
  expandDown,
  warningNoteIcon,
  redCarbonCircle,
  yellowCarbonCircle,
  greenCarbonCircle,
  greenIcon,
  grayIcon,
  exclamationCircleSolid,
  copyIcon,
  copyIconFill,
  YellowInfo,
  yellowIcon,
  menuUnFold,
  menuFold,
  expandNavigation,
  expandCloseNavigation,
  arrowLeftWhite,
  arrowRightWhite,
  refundIcon,
  cardIcon,
  errorPayment,
  successPayment,
  copyPayment,
  syncTransaction,
  check,
  availableWarning,
  kovenaPwb,
  processPayoutMulti,
  warningPayoutMulti,
  carbonParentNode
};
